import {
  REVENUE_OFFICE_REQUEST,
  REVENUE_OFFICE_SUCCESS,
  REVENUE_OFFICE_FAIL,

  CREATE_REVENUE_OFFICE_REQUEST,
  CREATE_REVENUE_OFFICE_SUCCESS,
  CREATE_REVENUE_OFFICE_FAIL,

  UPDATE_REVENUE_OFFICE_REQUEST,
  UPDATE_REVENUE_OFFICE_SUCCESS,
  UPDATE_REVENUE_OFFICE_FAIL,

  DELETE_REVENUE_OFFICE_REQUEST,
  DELETE_REVENUE_OFFICE_SUCCESS,
  DELETE_REVENUE_OFFICE_FAIL,

  CLEAR_ERROR,
} from "../../../constants/Master/LocationMasters/RevenueOfficeConstant";


// create, update, delete and get all
export const getRevenueOfficesReducer = (state = { revenueOffices: [] }, action) => {
  switch (action.type) {
    case REVENUE_OFFICE_REQUEST:
    case CREATE_REVENUE_OFFICE_REQUEST:
    case UPDATE_REVENUE_OFFICE_REQUEST:
    case DELETE_REVENUE_OFFICE_REQUEST:
      return {
        ...state,
        loading: true,
        message: null,
        status: null,
        error: null,
      };

    case REVENUE_OFFICE_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueOffices: action.payload,
        message: null,
        status: null,
      };

    case CREATE_REVENUE_OFFICE_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueOffices: [...state.revenueOffices, action.payload],
        message: action.message,
        status: action.status,
      };

    case UPDATE_REVENUE_OFFICE_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueOffices: state.revenueOffices.map((item) =>
          (item.revenueOfficeId === action.payload.revenueOfficeId) ? action.payload : item
        ),
        message: action.message,
        status: action.status,
      };

    case DELETE_REVENUE_OFFICE_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueOffices: action?.payload?.isDelete ?
          state.revenueOffices.filter((item) =>
            item.revenueOfficeId !== action.payload.revenueOfficeId
          )
          :
          state.revenueOffices.map((item) =>
            (item.revenueOfficeId === action.payload.revenueOfficeId) ? action.payload : item
          ),
        message: action.message,
        status: action.status,
      };

    case REVENUE_OFFICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_REVENUE_OFFICE_FAIL:
    case UPDATE_REVENUE_OFFICE_FAIL:
    case DELETE_REVENUE_OFFICE_FAIL:
      return {
        ...state,
        loading: false,
        message: action.message,
        status: action.status,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
        message: null,
      };

    default:
      return state;
  }
};